module.exports = __webpack_public_path__ + "static/media/rar.b0e76f47.svg";